import { useId, useState } from "react";
import { ResponsiveImage } from "./responsive-image";

export function BeforeAfter() {
  const [position, setPosition] = useState(52);
  const id = useId();

  return (
    <div className="before-after" style={{ "--position": `${position}%` } as React.CSSProperties}>
      <ResponsiveImage
        name="interior-before"
        alt="Izvorni, skromno namješten dnevni boravak"
        className="before-after__image"
        sizes="(max-width: 900px) 100vw, 67vw"
        loading="eager"
        fetchPriority="high"
      />
      <div className="before-after__after" aria-hidden="true">
        <ResponsiveImage
          name="interior-after"
          alt=""
          className="before-after__image"
          sizes="(max-width: 900px) 100vw, 67vw"
          loading="eager"
          fetchPriority="high"
        />
      </div>
      <span className="before-after__label before-after__label--before">Original</span>
      <span className="before-after__label before-after__label--after">Prijedlog</span>
      <div className="before-after__line" aria-hidden="true">
        <span>↔</span>
      </div>
      <label className="sr-only" htmlFor={id}>
        Usporedi original i rezultat
      </label>
      <input
        id={id}
        className="before-after__range"
        type="range"
        min="0"
        max="100"
        value={position}
        onChange={(event) => setPosition(Number(event.target.value))}
      />
    </div>
  );
}
